import { makeAutoObservable, runInAction } from "mobx";
import { Product } from "../../../types/product";
import http from "../../../libs/http";
import appStore from "../../../stores/appStore";
import _ from "lodash";

class ProductStore {

    product?: Product;

    selectedProduct?: Product;

    isLoading: boolean = false;

    isLoadingSelected: boolean = false;


    constructor() {
        makeAutoObservable(this);
    }


    getProductByKey = async (refKey: string, toggleFavorite: boolean = false) => {

        if(!toggleFavorite) this.startLoading();
        const { data }  = await http.get<Product>(`api/products/get/${refKey}`);
        runInAction(() => {
            this.product = data;
        })
        if(!toggleFavorite) this.finishLoading();
    }

    getSelectedProductByKey = async (refKey: string) => {
        this.startLoadingSelected();
        const { data }  = await http.get<Product>(`api/products/get/${refKey}`);
        runInAction(() => {
            this.selectedProduct = data;
        })
        this.startLoadingSelected();
    }


    startLoading() {
        runInAction(() => {
            this.isLoading = true
        })
    }

    finishLoading() {
        runInAction(() => {
            this.isLoading = false
        })
    }

    startLoadingSelected() {
        runInAction(() => {
            this.isLoadingSelected = true
        })
    }

    finishLoadingSelected() {
        runInAction(() => {
            this.isLoadingSelected = false
        })
    }

    resetSelectedProduct() {
        runInAction(() => {
            this.selectedProduct = undefined;
        })
    }

    get availavleCurrentCity()
    {
        return _.uniqBy(this.product?.stocks?.filter((i) => i.Stock?.includes(appStore.selectedCity) && i.qnt > 0 && !i.Stock.includes('83.')), 'Stock');
    }

    get totalQnt(): number
    {

        console.log(this.availavleCurrentCity.reduce((sum, item) => sum + item?.qnt, 0));
        

        return this.availavleCurrentCity.reduce((sum, item) => sum + item.qnt, 0) || 0;
    }

    get totalQntAnotherCity(): number
    {
        return this.availavleAnotherCity.reduce((sum, item) => sum + item.qnt, 0) || 0; 
    }

    get availavleAnotherCity()
    {
        return _.uniqBy(this.product?.stocks?.filter((i) => !i?.Stock?.includes(appStore.selectedCity) &&  i?.qnt > 0 && !i.Stock?.includes('83.') && !i.Stock?.includes('99.')), 'Stock');
    }
}

export default new ProductStore();